var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFarmMachine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 79,
    viewBox: "0 0 67 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6946 64.9581C55.6767 61.3261 66 48.6186 66 33.5C66 15.5507 51.4493 1 33.5 1C15.5507 1 1 15.5507 1 33.5C1 48.1716 10.7218 60.5725 24.0749 64.6123L33 78L41.6946 64.9581Z",
    fill: "#00C781"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6946 64.9581L41.5689 64.4742L41.3843 64.5221L41.2786 64.6808L41.6946 64.9581ZM24.0749 64.6123L24.4909 64.3349L24.3914 64.1857L24.2197 64.1337L24.0749 64.6123ZM33 78L32.584 78.2774L33 78.9014L33.416 78.2774L33 78ZM65.5 33.5C65.5 48.3853 55.336 60.898 41.5689 64.4742L41.8203 65.4421C56.0174 61.7542 66.5 48.8519 66.5 33.5H65.5ZM33.5 1.5C51.1731 1.5 65.5 15.8269 65.5 33.5H66.5C66.5 15.2746 51.7254 0.5 33.5 0.5V1.5ZM1.5 33.5C1.5 15.8269 15.8269 1.5 33.5 1.5V0.5C15.2746 0.5 0.5 15.2746 0.5 33.5H1.5ZM24.2197 64.1337C11.0716 60.156 1.5 47.9451 1.5 33.5H0.5C0.5 48.398 10.372 60.9891 23.9301 65.0909L24.2197 64.1337ZM33.416 77.7226L24.4909 64.3349L23.6588 64.8896L32.584 78.2774L33.416 77.7226ZM41.2786 64.6808L32.584 77.7226L33.416 78.2774L42.1106 65.2355L41.2786 64.6808Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_892_13728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8711 24.0781H42.147V31.4888",
    stroke: "#333333",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.838 16.1152H23.918V27.6806L39.3323 30.5274L33.838 16.1152Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.519 16.1152C20.166 16.1152 20.166 19.2735 20.166 19.2735V26.8354L23.9186 27.6717V16.1152H23.519Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8906 34.7852V28.0595L20.4966 25.3906H27.2721L29.9519 28.2063H44.9623L49.5228 34.932V43.5838H27.6761C27.6761 43.5838 17.8906 34.3715 17.8906 34.7852Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6551 45.4489C31.5956 40.6508 29.3709 35.15 24.686 33.1626C20.001 31.1752 14.63 33.4537 12.6895 38.2518C10.7489 43.0498 12.9737 48.5506 17.6586 50.538C22.3435 52.5254 27.7145 50.247 29.6551 45.4489Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5902 41.8523C24.5902 42.5447 24.3898 43.2215 24.0142 43.7972C23.6386 44.3729 23.1047 44.8216 22.4802 45.0866C21.8556 45.3515 21.1683 45.4208 20.5052 45.2858C19.8422 45.1507 19.2331 44.8173 18.7551 44.3277C18.277 43.8381 17.9515 43.2143 17.8196 42.5353C17.6877 41.8562 17.7554 41.1523 18.0141 40.5126C18.2728 39.8729 18.7109 39.3262 19.273 38.9415C19.8352 38.5569 20.496 38.3516 21.1721 38.3516C22.0786 38.3516 22.9481 38.7204 23.5891 39.3769C24.2301 40.0334 24.5902 40.9238 24.5902 41.8523Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2044 49.6874C53.2466 47.5959 53.2466 44.2049 51.2044 42.1134C49.1622 40.0219 45.8512 40.0219 43.809 42.1134C41.7668 44.2049 41.7668 47.5959 43.809 49.6874C45.8512 51.7789 49.1622 51.7789 51.2044 49.6874Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2364 45.9004C49.2364 46.2523 49.1345 46.5963 48.9436 46.8889C48.7527 47.1815 48.4813 47.4095 48.1639 47.5442C47.8464 47.6789 47.4971 47.7141 47.1601 47.6455C46.8231 47.5768 46.5135 47.4074 46.2706 47.1585C46.0276 46.9097 45.8621 46.5926 45.7951 46.2475C45.7281 45.9024 45.7625 45.5446 45.894 45.2195C46.0255 44.8944 46.2481 44.6165 46.5338 44.421C46.8195 44.2254 47.1554 44.1211 47.499 44.1211C47.9598 44.1211 48.4017 44.3086 48.7275 44.6422C49.0533 44.9759 49.2364 45.4285 49.2364 45.9004Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8398 32.8633V35.6078",
    stroke: "#333333",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9219 32.8633V35.6078",
    stroke: "#333333",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0059 32.8633V35.6078",
    stroke: "#333333",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0859 32.8633V35.6078",
    stroke: "#333333",
    strokeWidth: 1.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_892_13728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 39,
    fill: "white",
    transform: "translate(11 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmMachine);
export default __webpack_public_path__ + "static/media/farm-machine.3fa62f1f0d7052cb4dcdad2e72b31ea5.svg";
export { ForwardRef as ReactComponent };